import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/Layout.vue'
import { getToken } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'system-dashboard',
        name: 'SystemDashboard',
        component: () => import('../views/system-dashboard/index.vue'),
        meta: { title: '系统看板' }
      },
      {
        path: 'course-dashboard',
        name: 'CourseDashboard',
        component: () => import('../views/course-dashboard/index.vue'),
        meta: { title: '课程看板' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'channel',
        name: 'Channel',
        component: () => import('../views/channel/index.vue'),
        meta: { title: '频道管理' }
      },
      {
        path: 'knowledge/collection',
        name: 'KnowledgeCollection',
        component: () => import('../views/knowledge/collection.vue'),
        meta: { title: '知识合辑' }
      },
      {
        path: 'knowledge/category',
        name: 'KnowledgeCategory',
        component: () => import('../views/knowledge/category.vue'),
        meta: { title: '知识分类' }
      },
      {
        path: 'knowledge',
        name: 'Knowledge',
        component: () => import('../views/knowledge/index.vue'),
        meta: { title: '知识管理' }
      },
      {
        path: 'recommend',
        name: 'Recommend',
        component: () => import('../views/recommend/index.vue'),
        meta: { title: '推荐配置' }
      },
      {
        path: 'gift',
        name: 'Gift',
        component: () => import('../views/gift/index.vue'),
        meta: { title: '礼物管理' }
      },
      {
        path: 'course',
        name: 'Course',
        component: () => import('../views/course/index.vue'),
        meta: { title: '课程管理', keepAlive: true }
      },
      {
        path: 'course/create',
        name: 'CourseCreate',
        component: () => import('../views/course/create.vue'),
        meta: { title: '创建课程' }
      },
      {
        path: 'course/edit/:id',
        name: 'CourseEdit',
        component: () => import('../views/course/create.vue'),
        meta: { title: '编辑课程' }
      },
      {
        path: 'course/detail/:id',
        name: 'CourseDetail',
        component: () => import('../views/course/detail.vue'),
        meta: { title: '课程详情' }
      },
      {
        path: 'course/replay',
        name: 'CourseReplay',
        component: () => import('../views/course/replay.vue'),
        meta: { title: '直播回看' }
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import('../views/account/account.vue'),
        meta: { title: '账户管理' }
      },
      {
        path: 'live-room',
        name: 'LiveRoom',
        component: () => import('../views/live-room/index.vue'),
        meta: { title: '直播间' }
      },
      {
        path: 'question-bank',
        name: 'QuestionBank',
        component: () => import('../views/question-bank/index.vue'),
        meta: { title: '题库管理' }
      },
      {
        path: 'exam-record',
        name: 'ExamRecord',
        component: () => import('../views/exam-record/index.vue'),
        meta: { title: '考试记录' }
      },
      {
        path: 'exam-manage',
        name: 'ExamManage',
        component: () => import('../views/exam-manage/index.vue'),
        meta: { title: '考试管理' }
      },
      {
        path: 'settings/member',
        name: 'MemberSettings',
        component: () => import('../views/settings/member.vue'),
        meta: { title: '会员设置' }
      },
      {
        path: 'settings/system',
        name: 'SystemSettings',
        component: () => import('../views/settings/system.vue'),
        meta: { title: '系统设置' }
      },
      {
        path: 'log',
        name: 'Log',
        component: () => import('../views/log/index.vue'),
        meta: { title: '日志管理' }
      },
      {
        path: 'permission/menu',
        name: 'PermissionMenu',
        component: () => import('../views/permission/menu/index.vue'),
        meta: { title: '菜单管理' }
      },
      {
        path: 'permission/client-menu',
        name: 'PermissionClientMenu',
        component: () => import('../views/permission/client-menu/index.vue'),
        meta: { title: '客户端菜单' }
      },
      {
        path: 'permission/role',
        name: 'PermissionRole',
        component: () => import('../views/permission/role/index.vue'),
        meta: { title: '管理员角色' }
      },
      {
        path: 'permission/client-role',
        name: 'PermissionClientRole',
        component: () => import('../views/permission/client-role/index.vue'),
        meta: { title: '客户端角色' }
      },
      {
        path: 'permission/admin',
        name: 'PermissionAdmin',
        component: () => import('../views/permission/admin/index.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'personal',
        name: 'Personal',
        component: () => import('../views/personal/index.vue'),
        meta: { title: '个人信息' }
      },
      {
        path: 'test/live',
        name: 'TestLive',
        component: () => import('../views/test/live-play.vue'),
        meta: { title: '直播与群组测试' }
      }
    ]
  },
  {
    path: '/host-workbench',
    name: 'HostWorkbench',
    component: () => import('../views/host-workbench/index.vue'),
    meta: { title: '主播工作台' }
  }
]

const router = new VueRouter({
  // 生产以 /manage 前缀部署：路由使用 history 模式并设置 base，使路径统一带 /manage 前缀；
  // 开发环境未定义该变量时保持默认（hash 模式），不影响本地调试。
  mode: process.env.VUE_APP_ROUTER_BASE ? 'history' : 'hash',
  base: process.env.VUE_APP_ROUTER_BASE || '/',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 登录态超过 24 小时视为过期，getToken 返回 null 并自动清除
  const token = getToken()
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

// 全局路由异常兜底：避免并发跳转（如 401 触发跳登录）抛出 Navigation cancelled 等未捕获错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  const result = originalPush.call(this, location, onComplete, onAbort)
  // 某些情况下（传了 onComplete/onAbort 回调或重复导航）push 可能返回 undefined，
  // 此时不调用 .catch，避免 "can't access property catch" 报错。
  if (result && typeof result.catch === 'function') {
    return result.catch(err => {
      if (VueRouter.isNavigationFailure && VueRouter.isNavigationFailure(err)) {
        return err
      }
      // 忽略已知的导航取消错误（重复跳转到同一路由等）
      if (err && (err.name === 'NavigationDuplicated' || err.name === 'NavigationCancelled')) {
        return err
      }
      return Promise.reject(err)
    })
  }
  return result
}

export default router
